import { EntityType } from "@common/Common.types";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { RiskAreaHighestRisk } from "./RiskAreaRisks.types";

export function useRiskAreaRisksTile(entityType: EntityType, entityId: string) {
    const { data, isLoading } = useDotLegalQuery<Array<RiskAreaHighestRisk>>(`/entities/${entityType}/${entityId}/risk-areas/risk-levels`);

    return {
        riskAreas: data ?? [],
        isLoading,
    };
}
